import styled from 'styled-components';

export const Wrapper = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;

export const Summary = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.text.emptyState};
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h4`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.actionBar};
`;
